import PurchaseConfirmationModalAutoBid from './purchaseConfirmationModalAutoBid'

export default PurchaseConfirmationModalAutoBid
